import UserTypeRadio from "./UserTypeRadio";

export default UserTypeRadio;
